import {ACTION_TYPE} from "utils/constants";
import produce from "immer";

const initialState = {
  isOpened: {
    Data: true,
    Transform: true,
    Background: true,
  },
  currentTab: "Object",
};

const propertyPanel = (state = initialState, action) => {
  const {type, payload} = action;
  switch (type) {
    case ACTION_TYPE.TOGGLE_COMPONENT:
      return produce(state, draft => {
        draft.isOpened[payload.component] = !draft.isOpened[payload.component];
      });
    case ACTION_TYPE.CHANGE_CURRENT_PROPERTY_TAB:
      return produce(state, draft => {
        draft.currentTab = payload;
      });
    default:
      return state;
  }
};

export default propertyPanel;
